import { render, staticRenderFns } from "./CarBannerTwoColumn.vue?vue&type=template&id=b7ca06c0&scoped=true"
import script from "./CarBannerTwoColumn.vue?vue&type=script&lang=js"
export * from "./CarBannerTwoColumn.vue?vue&type=script&lang=js"
import style0 from "./CarBannerTwoColumn.vue?vue&type=style&index=0&id=b7ca06c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ca06c0",
  null
  
)

export default component.exports